import axios from "axios";

var API: any;

// Set API URL
const hostName: string = window.location.hostname;
const langPath = (window as any).langPath || "en-US";
const lcid = (window as any).lcid || "1033";
const apiUrl: string = (window as any).apiurl
  ? (window as any).apiurl + "api"
  : "";
const apiUrlCdax = apiUrl;
API = apiUrlCdax; // default value set.
// Function to refresh token
const refreshToken = async (): Promise<string | undefined> => {
  
  const url_auth = `https://${hostName}/_services/auth/token`;
  try {
    const response = await axios.post(url_auth);
    const token = response.data;
    localStorage.setItem("ngStorage-token", token);
    return token; // Return the refreshed token
  } catch (e: any) {
    if (
      axios.isAxiosError(e) &&
      (e.response?.status === 401 ||
        e.response?.status === 500 ||
        e.response?.status === 302)
    ) {
      localStorage.removeItem("ngStorage-token");
      window.location.href =
        "https://" +
        window.location.host +
        "/SignIn?returnUrl=" +
        window.location.pathname;
    }
    return e;
  }
};

const getHeader = async (): Promise<any | undefined> => {
  const token = await refreshToken();
  const HEADERS = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return HEADERS;
};

// API Methods
export const apiGet = async (url: string) => {
  try {
    //var header = await getHeader();
    return await axios.get(`${API}${url}`);
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response;
    }
    return e;
  }
};
export const apiGetWithHeader = async (url: string) => {
  try {
    var header = await getHeader();
    return await axios.get(`${API}${url}`, header);
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response;
    }
    return e;
  }
};

export const apiPost = async (url: string, payload: any) => {
  try {
    let header = await getHeader();
    const payloadData = {
      ...payload,
      'datalang': langPath,
      'lcid': lcid
    }
    return await axios.post(`${API}${url}`, payloadData, header);
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response?.data;
    }
    return e;
  }
};
export const apiPostUploadFiles = async (url: string, payload: any) => {
  const token = await refreshToken();

  try {
    // var header = await getHeader();
    return await axios.post(`${API}${url}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        // "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response?.data;
    }
    return e;
  }
};

export const apiSaveContact = async (formData: any) => {
  try {
    const data = {
      individualorcompany: formData.userType,
      fname: formData.firstname,
      lname: formData.lastname,
      email: formData.email,
      cguid: formData.country,
      cname: formData.cname,
      contactid: "85680C15-7814-E711-80FC-5065F38AD971",
      Province: formData.province,
      City: formData.city,
      cmpnyname: formData.company,
      companyaddress: formData.companyAddress,
      AddressLine1: formData.addressLine1,
      AddressLine2: " ::",
      PostalCode: formData.postalCode,
      isAddressValidated: 0,
      isAddressVerify: 0,
      lcid: lcid,
      phnum: formData.phoneNumber,
      datalang: langPath,
    };
    return await axios.post(
      `${API}/customerportal/signup/v1/save_contact`,
      data
    );
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response?.data;
    }
    return e;
  }
};

export const apiGetFileDownload = async (url: string) => {
  try {
    var header = await getDownFileHeader();
    return await axios.get(`${API}${url}`, header);
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response;
    }
    return e;
  }
};

const getDownFileHeader = async (): Promise<any | undefined> => {
  const token = await refreshToken();
  const HEADERS = {
    headers: {
      Accept: "application/octet-stream",
      Authorization: `Bearer ${token}`,
    },
    responseType: "arraybuffer",
  };
  return HEADERS;
};

// array buffer
export const apiGetFileDownloadSiteAccount = async (url: string) => {
  try {
    var header = await getDownFileHeaderSiteAccount();
    return await axios.get(`${API}${url}`, header);
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response;
    }
    return e;
  }
};
// array buffer header
const getDownFileHeaderSiteAccount = async (): Promise<any | undefined> => {
  const token = await refreshToken();
  const HEADERS = {
    headers: {
      Accept: "application/json, text/plain, */*",
      Authorization: `Bearer ${token}`,
    },
    responseType: "arraybuffer",
  };
  return HEADERS;
};